import { render, staticRenderFns } from "./soporte.vue?vue&type=template&id=62d4b253"
import script from "./soporte.vue?vue&type=script&lang=js"
export * from "./soporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports